export default __webpack_public_path__ + "static/media/product1.759ba8f4.png";